var render = function (_h,_vm) {var _c=_vm._c;return _c('query-pagination',{attrs:{"totalPages":_vm.props.totalPages}})}
var staticRenderFns = []

export { render, staticRenderFns }